import { render, staticRenderFns } from "./report_post_value_tiktok.vue?vue&type=template&id=000c0992&"
import script from "./report_post_value_tiktok.vue?vue&type=script&lang=js&"
export * from "./report_post_value_tiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports